export const actions = {
    GET_QUESTION_LIST : 'GET_QUESTION_LIST',
    SET_QUESTION_LIST : 'SET_QUESTION_LIST',
    ADD_QUESTION : 'ADD_QUESTION',
    DELETE_QUESTION : 'DELETE_QUESTION',
    GET_QUESTION : 'GET_QUESTION',
    SET_QUESTION : 'SET_QUESTION',
    DOWNLOAD_QUESTION : 'DOWNLOAD_QUESTION',

    SET_QUESTION_DEFAULT_DATA: 'SET_QUESTION_DEFAULT_DATA',
    SET_QUESTION_DATA: 'SET_QUESTION_DATA',
    GET_QUESTION_DATA: 'GET_QUESTION_DATA',

    GET_QUESTION_DIFFICULTIES: 'GET_QUESTION_DIFFICULTIES',
    SET_QUESTION_DIFFICULTIES: 'SET_QUESTION_DIFFICULTIES',
    REDIRECT_TO_ALMS_QUESTION_BANK: 'REDIRECT_TO_ALMS_QUESTION_BANK',
    QUESTION_BANK_DOWNLOAD_TEMPLATE_EXCEL: 'QUESTION_BANK_DOWNLOAD_TEMPLATE_EXCEL',
    SET_FILE_MULTI_UPLOAD_ID: 'SET_FILE_MULTI_UPLOAD_ID',
    GET_REFRESH_UPLOAD_MULTI_QUESTION: 'GET_REFRESH_UPLOAD_MULTI_QUESTION',
    SET_REFRESH_UPLOAD_MULTI_QUESTION: 'SET_REFRESH_UPLOAD_MULTI_QUESTION'
};